module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/venetian-blind-window/window.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/venetian-blind-window/window.obj
// module id = 495
// module chunks = 0